export interface ProcessoPreCadastroProdutoPdm {
  NCODIGO: number;
  NCODIGOPROCESSOCADASTRO: number;
  
  // Solicitante
  CGRPNVL1: string;   // Grupo Nvl 1
  CGRPNVL2: string;   // Grupo Nvl 2
  CB1XPDM: string;    // PDM
  ACARACTERISTICAS: Array<Caracteristica>;
  CB1DESC: string;    // Descrição curta
  CB1XDESCL: string;  // Descrição longa
  CB1POSIPI: string;  // NCM
  CB1UM: string;      // UM
  CB1SEGUM: string;   // Segunda UM
  NB1CONV: number;    // Fator de Conversão de UM
  CB1MRP: string;     // Controle de estoque
  NB1EMIN: number;    // Estoque mínimo
  NB1EMAX: number;    // Estoque máximo
  CSETOR: string;     // Setor

  // Compras
  CB1GRUPO: string;
  CB1LOCPAD: string;
  CB1XFAM: string;

  // Controladoria
  CB1TIPO: string;
  CB1CONTA: string;
  CB1XCTACUS: string;
  CB1XCTADEA: string;
  CB1XCTADEC: string;
  CB1XTPPRD: string;
  CB1TE: string;
  CB1XTPSPED: string;

  CB1COD: string;
  CUSOAPLICACAO: string;
  CLOCALUSO: string;
  LCHANGE: boolean;
}

export const defaultProcessoPreCadastroProdutoPdm = (): ProcessoPreCadastroProdutoPdm => {
  return {
    NCODIGO: 0,
    NCODIGOPROCESSOCADASTRO: 0,
    CGRPNVL1: '',
    CGRPNVL2: '',
    CB1XPDM: '',
    CB1POSIPI: '',
    ACARACTERISTICAS: [],
    CB1DESC: '',
    CB1XDESCL: '',
    CB1UM: '',
    CB1SEGUM: '',
    CB1MRP: '',
    NB1EMIN: 0,
    NB1EMAX: 0,
    CSETOR: '',
    CB1GRUPO: '',
    CB1XFAM: '',
    CB1LOCPAD: '',
    CB1TIPO: '',
    NB1CONV: 0,
    CB1CONTA: '',
    CB1XCTACUS: '',
    CB1XCTADEA: '',
    CB1XCTADEC: '',
    CB1XTPPRD: '5',
    CB1TE: '',
    CB1XTPSPED: '',
    CB1COD: '',
    CUSOAPLICACAO: '',
    CLOCALUSO: '',
    LCHANGE: false,
  };
};

export interface ProcessoPreCadastroProdutoPdmListaItem {
  NPROCESSOCODIGO: number;
  NCODIGO: number;
  CSTATUS: string;
  CURGENTE: string;
  CB1COD: string;
  CB1DESC: string;
  CUSRID: string;
  CUSRNOME: string;
  DINCLUSAO: Date | undefined;
  DFINALIZACAO: Date | undefined;
}

export const defaultProcessoPreCadastroProdutoListaItem = (): ProcessoPreCadastroProdutoPdmListaItem => {
  return {
    NPROCESSOCODIGO: 0,
    NCODIGO: 0,
    CSTATUS: '',
    CURGENTE: '',
    CB1COD: '',
    CB1DESC: '',
    CUSRID: '',
    CUSRNOME: '',
    DINCLUSAO: undefined,
    DFINALIZACAO: undefined,
  };
};

export interface ProcessoPreCadastroProdutoPdmLista {
  items: Array<ProcessoPreCadastroProdutoPdmListaItem>;
  hasNext: boolean;
}

export const defaultProcessoCadastroDtoList = (): ProcessoPreCadastroProdutoPdmLista => {
  return {
    items: [],
    hasNext: false,
  };
};

export interface ProcessoPreCadastroProdutoPdmDto {
  PRODUTO: ProcessoPreCadastroProdutoPdm;
  CHISTORICO: string;
  CDECISAO: string;
  CURGENTE: string;
  CARQUIVOSCHAVE: string;
}

export interface Caracteristica {
  CSEQUENCIA: string;
  CCODCARACT: string;
  CCARACTERISTICA: string;
  CITEM: string;
  CITEMDESC: string;
  CDESCC: string;
  CDESCL: string;
  CMODO: string;
  CUSADESCC: string;
  CUSADESCL: string;
  CUSADESC: string;
}

export const defaultCaracteristica = (): Caracteristica => {
  return {
    CSEQUENCIA: '',
    CCODCARACT: '',
    CCARACTERISTICA: '',
    CITEM: '',
    CITEMDESC: '',
    CDESCC: '',
    CDESCL: '',
    CMODO: '',
    CUSADESCC: '',
    CUSADESCL: '',
    CUSADESC: '',
  };
};

export interface CaracteristicaList {
  items: Array<Caracteristica>;
}

export interface CaracteristicaItem {
  CZC4COD: string;
  CZC4DESCC: string;
  CZC4DESCL: string;
  CZC4CDESCS: string;
}

